import { get, compact } from 'lodash-es'
import { CONSTANTS as AIMEOS_ADDRESS_CONSTANTS } from './aimeos-customer-address-constants'

export const ADDRESS_CONSTANTS = {
  DATA: 'DATA',
  DELIVERY_ADDRESSES: 'deliveryAddresses',
  PAYMENT_ADDRESS: 'paymentAddress',
  ADDRESS1: 'Address1',
  ADDRESS2: 'Address2',
  ADDRESS3: 'Address3',
  CITY: 'City',
  COMPANY: 'Company',
  COUNTRY_ID: 'CountryId',
  EMAIL: 'Email',
  FIRSTNAME: 'Firstname',
  ID: 'Id',
  LANGUAGE_ID: 'LanguageId',
  LASTNAME: 'Lastname',
  LATITUDE: 'Latitude',
  LONGITUDE: 'Longitude',
  PARENT_ID: 'ParentId',
  POSITION: 'Position',
  POSTAL: 'Postal',
  SALUTATION: 'Salutation',
  SAP_ADDRESS_ID: 'SapAddressId',
  SITE_ID: 'SiteId',
  STATE: 'State',
  TELEFAX: 'Telefax',
  TELEPHONE: 'Telephone',
  TITLE: 'Title',
  VAT_ID: 'VatID',
  WEBSITE: 'Website',
}

export const transformAddress = address => ({
  id: get(address, ADDRESS_CONSTANTS.ID),
  SapAddressId: get(address, ADDRESS_CONSTANTS.SAP_ADDRESS_ID),
  addressData: address,
  transformedData: compact([
    get(address, ADDRESS_CONSTANTS.COMPANY),
    get(address, ADDRESS_CONSTANTS.ADDRESS1),
    get(address, ADDRESS_CONSTANTS.ADDRESS2),
    get(address, ADDRESS_CONSTANTS.ADDRESS3),
    compact([get(address, ADDRESS_CONSTANTS.POSTAL), get(address, ADDRESS_CONSTANTS.CITY)]).join(
      ' ',
    ),
    get(address, ADDRESS_CONSTANTS.COUNTRYID),
    get(address, ADDRESS_CONSTANTS.EMAIL),
  ]),
})

export const transformAimeosAddress = address => ({
  id: get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.ID),
  addressData: address,
  transformedData: compact([
    get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.COMPANY),
    get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.ADDRESS1),
    get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.ADDRESS2),
    get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.ADDRESS3),
    compact([
      get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.POSTAL),
      get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.CITY),
    ]).join(' '),
    get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.COUNTRYID),
    get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.EMAIL),
  ]),
})

export const transformLeanAddress = address => ({
  id: get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.ID),
  email: get(address, AIMEOS_ADDRESS_CONSTANTS.ATTRIBUTE.EMAIL),
})

export const getJoinedAddress = address =>
  compact([
    get(address, ADDRESS_CONSTANTS.ADDRESS1),
    get(address, ADDRESS_CONSTANTS.ADDRESS2),
    get(address, ADDRESS_CONSTANTS.ADDRESS3),
  ]).join(', ')
